var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Woodie"},[_c('ol',[_c('li',[_vm._v("괴물고기를 2개씩 먹어가며 랜덤 동물로 변신합니다")]),_vm._v(" "),_c('li',[_vm._v("명데와 같은 동물로 변신한 사람들은 살아남습니다")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7556db0f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mission/Woodie.vue
// module id = 139
// module chunks = 1